/**
 * Suggested industries for client/lead. Used as autocomplete suggestions;
 * value is free text, so custom entries are allowed.
 */
export const INDUSTRIES = [
  'Agriculture & Farming',
  'Automotive',
  'Aviation & Aerospace',
  'Construction & Engineering',
  'Education',
  'Energy & Utilities',
  'Entertainment & Media',
  'Financial Services & Banking',
  'Food & Beverage',
  'Government & Public Sector',
  'Healthcare',
  'Hospitality & Hotels',
  'Manufacturing',
  'Mining & Natural Resources',
  'Non-Profit',
  'Real Estate',
  'Retail',
  'Technology & Software',
  'Telecommunications',
  'Transportation & Logistics',
  'Warehousing & Distribution',
  'Other',
];
